import React from "react"
import { Table, TableBody, TableRow, TableRowColumn, FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import AppStateStore from "../../../../stores/AppStateStore"
import AddNoteTypeDialog from "./AddNoteTypeDialog"
import AccountStore from "../../../../stores/AccountStore"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import { green500 } from "material-ui/styles/colors"
import { INoteType } from "../../../../models"

interface IProps {
    isAccountManager?: boolean
    accountManagerId?: string
}

interface IState {
    loading: boolean,
    expand: boolean
    noteTypes: INoteType[]
    openAddNoteTypeDialog: boolean
    selectedNoteType: INoteType
    loadingSpinner: boolean
}

export default class NoteTypesCard extends React.Component<IProps, IState> {
    private refreshTimer

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            expand: false,
            openAddNoteTypeDialog: false,
            selectedNoteType: null,
            loadingSpinner: false,
            noteTypes: [],
        }
    }

    componentDidMount() {
        this.getNoteTypes()
    }

    componentWillUnmount() {
        this.refreshTimer &&
            clearInterval(this.refreshTimer)
    }

    getNoteTypes() {
        this.setState({
            loading: true,
            loadingSpinner: true
        })

        api.getNoteTypes(AccountStore.getCurrentAccount().Id)
            .then(res => {
                this.setState({ noteTypes: this.getSortedNoteTypes(res.data), loading: false, loadingSpinner: false })
            })
    }

    update(noteType: INoteType) {
        api.updateNoteType(AccountStore.getCurrentAccount().Id, noteType)
            .then((res) => {
                this.setState({
                    selectedNoteType: res.data,
                    loading: false,
                    openAddNoteTypeDialog: false,
                }, () => {
                    this.getNoteTypes()
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
            })
    }

    add(noteType: INoteType) {
        api.addNoteType(AccountStore.getCurrentAccount().Id, noteType)
            .then((res) => {
                this.setState({
                    selectedNoteType: res.data,
                    loading: false,
                    openAddNoteTypeDialog: false,
                }, () => {
                    this.getNoteTypes()
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
            })
    }

    delete(noteType: INoteType) {
        api.deleteNoteType(AccountStore.getCurrentAccount().Id, noteType.Id)
            .then((res) => {
                this.setState({
                    selectedNoteType: null,
                    loading: false,
                    openAddNoteTypeDialog: false,
                }, () => {
                    this.getNoteTypes()
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
            })
            .catch(err =>
                AppStateStore.setProgressSnackbarContent(err.response.data.message)
            )
    }

    getSortedNoteTypes(noteTypes) {
        return noteTypes ?
            noteTypes
                .sort((a, b) => {
                    if (a.Name === b.Name) return 0
                    if (a.Name < b.Name) return -1
                    if (a.Name > b.Name) return 1
                })
                .sort((a, b) => {
                    if (a.Group === b.Group) return 0
                    if (a.Group < b.Group) return -1
                    if (a.Group > b.Group) return 1
                }) :
            []
    }

    render() {
        const readonly = false // !permissionHelper.isGlobalAdmin()
        const isGlobalAdmin = permissionHelper.isGlobalAdmin()


        return (
            <div>
                {(isGlobalAdmin || this.props.isAccountManager) &&
                    <FloatingActionButton
                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Btn-Add"}
                        style={{
                            position: "absolute",
                            marginTop: -93,
                            right: 42,
                            display: "inline-block",
                            zIndex: 100
                        }}
                        mini={true}
                        secondary={true}
                        onTouchTap={() => {
                            this.setState({ openAddNoteTypeDialog: true, selectedNoteType: null })
                        }}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                {this.state.loadingSpinner ?
                    <div className="spinner"><CircularProgress /></div> :
                    !this.state.noteTypes.length ? strings.NoNoteTypes :
                        <Table
                            multiSelectable={false}
                            selectable={false}
                            fixedHeader={true}
                            style={{ backgroundColor: "none", borderBottom: "1px solid rgb(224,224,224)", borderTop: "1px solid rgb(224,224,224)" }}
                        >
                            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                                <TableRow style={{ heigth: 45 }}>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        Data Type
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.Group}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.Name}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 150 }}>
                                        {strings.FrontEndFormScript}
                                    </TableRowColumn>
                                    {AccountStore.getNoteAttributesEnabled() &&
                                        <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 150 }}>
                                            Object Attribute
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={{ width: 40, textAlign: "center", paddingLeft: 5, paddingRight: 5 }}>
                                        {strings.Active}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 40 }}>
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 40 }}>
                                    </TableRowColumn>
                                </TableRow>
                                {this.state.noteTypes.map((row, i) =>
                                    <TableRow key={i} style={{ heigth: 45 }}>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                            {row.DataType && row.DataType.charAt(0).toUpperCase() + row.DataType.slice(1)}{!row.DataType && <span>All</span>}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                            {row.Group}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                            {row.Name}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 150 }}>
                                            {row.Scripts.FrontEndFormScript ? (<i className="fa fa-check" style={{ fontSize: 18, color: green500 }} />) : ""}
                                        </TableRowColumn>
                                        {AccountStore.getNoteAttributesEnabled() &&
                                            <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 150 }}>
                                                {row.ObjectAttribute ? (<i className="fa fa-check" style={{ fontSize: 18, color: green500 }} />) : ""}
                                            </TableRowColumn>
                                        }
                                        <TableRowColumn style={{ width: 40, textAlign: "center", paddingLeft: 5, paddingRight: 5 }} className="prevent-cell-click">
                                            {row.Active && <i className="fa fa-check" style={{ fontSize: 18, color: green500 }} />}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ width: 40, cursor: "pointer", textAlign: "right" }} className="prevent-cell-click">
                                            <i
                                                data-intercom-target={i === 0 && "NoteTypesTable-Btn-OpenAddNoteTypeDialog"}
                                                className="fa fa-pencil"
                                                style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                onClick={() => {
                                                    this.setState({ selectedNoteType: row, openAddNoteTypeDialog: true })
                                                }}
                                            />
                                        </TableRowColumn>
                                        <TableRowColumn style={{ width: 40, cursor: "pointer", textAlign: "right" }} className="prevent-cell-click">
                                            <i
                                                data-intercom-target={i === 0 && "ScheduledJobsTable-Btn-DeleteScheduledJob"}
                                                className="fa fa-trash-o"
                                                style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                onClick={() =>
                                                    AppStateStore.setConfirmDialogContent({
                                                        content: strings.AreYouSureYouWantToDeleteNoteType,
                                                        confirm: () => {
                                                            this.delete(row)
                                                        }
                                                    })
                                                }
                                            />
                                        </TableRowColumn>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                }
                {this.state.openAddNoteTypeDialog &&
                    <AddNoteTypeDialog
                        editNoteType={this.state.selectedNoteType}
                        handleClose={() => this.setState({ openAddNoteTypeDialog: false })}
                        handleAdd={noteType => this.add(noteType)}
                        handleUpdate={noteType => this.update(noteType)}
                    />
                }
            </div>
        )
    }
}